export default __webpack_public_path__ + "static/media/chariot.bc69d5ef.png";